//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { shallowEqual, useSelector } from 'react-redux'



//  ----------------------------------------------------------------------------
//  Selectors
//  ----------------------------------------------------------------------------

//  -- Examples data ------------------
const selector = (state) => state.classActivities;

//  -- Examples array selector --------

export const useClassActivities = () => {
    const selectedData = useSelector(selector, shallowEqual)
    return selectedData;
}
